module.exports = __webpack_public_path__ + "img/ov7_e010777310-v8_1.ce34382c.jpg";